import { c as _c } from "react/compiler-runtime";
import { Stack } from '@mui/material';
import Profile from './Profile';
import OrganisationSelector from './OrganisationSelecter';
import { HeaderProps } from '..';
const HeaderContent = t0 => {
  const $ = _c(5);
  const {
    unauthorized
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      ml: 1,
      width: "100%",
      justifyContent: "space-between",
      alignItems: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== unauthorized) {
    t2 = unauthorized ? null : <><OrganisationSelector /><Profile /></>;
    $[1] = unauthorized;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <Stack direction="row" spacing={3} sx={t1}>{t2}</Stack>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default HeaderContent;